import { render, staticRenderFns } from "./review-status-history-entry.vue?vue&type=template&id=5b7b5663"
import script from "./review-status-history-entry.vue?vue&type=script&lang=ts"
export * from "./review-status-history-entry.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports